'use client';

import React, { Suspense } from 'react';
import Link from 'next/link';
import LoginForm from './components/LoginForm';
import { getAuthFeatureConfig } from '@/lib/config';
import { AuthProvider } from '@/components/AuthContext';

function LoginCard() {
  const authConfig = getAuthFeatureConfig();
  const enabledMethods = authConfig?.enabledMethods ?? ['password'];
  const passwordEnabled = enabledMethods.includes('password');

  if (!passwordEnabled) {
    return (
      <div className="container mx-auto max-w-md px-4 py-12">
        <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-lg shadow-gray-100">
          <h1 className="text-2xl font-semibold text-gray-900">Авторизация временно недоступна</h1>
          <p className="mt-3 text-sm leading-6 text-gray-500">
            На сайте не активирован метод входа по паролю. Обратитесь в поддержку или администратора сайта.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-md px-4 py-12">
      <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-lg shadow-gray-100">
        <LoginForm />
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <AuthProvider>
      <Suspense
        fallback={
          <div className="container mx-auto max-w-md px-4 py-12">
            <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-lg shadow-gray-100">
              <div className="space-y-4">
                <div className="h-6 w-3/4 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
                <div className="h-10 w-full animate-pulse rounded bg-gray-200" />
                <div className="h-10 w-full animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-2/3 animate-pulse rounded bg-gray-100" />
              </div>
            </div>
          </div>
        }
      >
        <LoginCard />
      </Suspense>
    </AuthProvider>
  );
}
